import React from "react"
import PropTypes from "prop-types"
import {isEmpty} from "lodash"

import Form from "@irati/ui/src/Form"
import {H1} from "@irati/ui/src/Typography"
import Select from "@irati/ui/src/FormItem/Select"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import isTimeLimited from "@irati/deals/helpers/deals/isTimeLimited"

import TimeLimitedDeal from "../../components/ProductForms/TimeLimitedDeal"
import QuantityContainer from "./Quantity/QuantityContainer"
import LimitWrapper from "./LimitWrapper"
import SagaStep from "./SagaStep"

const SingleVoucherSelection = ({
  handleChange,
  handleClick,
  selected,
  products,
  deal,
  allowMultipleQuantity,
  formatMessage
}) => {
  const options = products.map((item) => {
    // TODO readd stock check on disabled property
    return {
      value: item.uuid,
      label: item.name
    }
  })
  const loadingOptions = isEmpty(options)
  return (
    <>
      <SagaStep />
      <H1 marginBottom={2}>
        <FormattedMessage id="perks.components.productForms.singleProductSelection.title" />
      </H1>
      {isTimeLimited(deal) && <TimeLimitedDeal deal={deal} />}
      <LimitWrapper deal={deal}>
        <Form>
          <Select
            placeholder={
              loadingOptions
                ? formatMessage({id: "perks.components.productForms.singleProductSelection.loading"})
                : formatMessage({id: "perks.components.productForms.singleProductSelection.select"})
            }
            value={selected && selected.uuid}
            isDisabled={loadingOptions}
            isClearable={false}
            isSearchable={false}
            name="selectedProduct"
            onChange={(value) => handleChange(value)}
            options={options} />
        </Form>
        {allowMultipleQuantity && selected && (
          <QuantityContainer deal={deal} products={products.filter((item) => item.uuid === selected)} handleClick={handleClick} />
        )}
      </LimitWrapper>
    </>
  )
}

SingleVoucherSelection.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleClick: PropTypes.func.isRequired,
  selected: PropTypes.string,
  products: PropTypes.array.isRequired,
  deal: PropTypes.object.isRequired,
  allowMultipleQuantity: PropTypes.bool,
  willReachMax: PropTypes.bool,
  formatMessage: PropTypes.func.isRequired,
  stock: PropTypes.object.isRequired
}

SingleVoucherSelection.defaultProps = {
  allowMultipleQuantity: false,
  willReachMax: false,
  selected: null
}

export default injectIntl(SingleVoucherSelection)
